import React from 'react';

const PreviewContext = React.createContext(null);
export const PreviewProvider = PreviewContext.Provider;

export default PreviewContext;
